<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  {{'alert.confirm' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<div class="row">
  <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
    <!--<em class="material-icons confirm-ico">
      info
    </em>-->
    <em class="fa fa-warning text-primary large"></em>
  </div>
  <div class="col-10 pl-0">
    <div [innerHTML]="msg | translate" style=" padding: 5px 7px 15px 0; font-size: medium; overflow-wrap: break-word;"></div>
  </div>
</div>
    
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && declineSignDocument()" appFocusFirstElement>
  <mat-dialog-content>
    <div class="row">
      <div class="col-2 pr-0"></div>
      <div class="col-10 pl-0">
        <mat-form-field class="mat-full-width">
          <textarea (focusout)="document.reason = document.reason.trim()" matInput type="text" name="reason" id="reason" rows="3" [(ngModel)]="document.reason" #reason="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && reason.invalid }" [placeholder]="'form.reason_cancel' | translate"
            maxlength="250" required></textarea>
            <mat-error *ngIf="f.submitted || reason.invalid">
              <span class="text-error" *ngIf="reason?.errors?.required">
                {{'validation.reason_cancel' | translate}}
              </span>
            </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="pt-2 pb-3">
    <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" class="mr-2">
      <mat-icon class="mr-0">cancel</mat-icon>{{ "button.ignore" | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" class="ml-2" [disabled]="reason.invalid" >
      <mat-icon class="mr-0">save</mat-icon>{{ "button.accept" | translate }}
    </button>
  </mat-dialog-actions>
</form>